import gql from 'graphql-tag'

export const teamQuery = gql`
    query team($teamId: Int!, $userId: Int) {
        team(teamId: $teamId, userId: $userId) {
            id
            name
            businessAccountId
            totalMembers
            totalQuotes
            totalSalesOrders
            createdAt
            createdBy {
                id
                displayName
                email
                createdAt
                updatedAt
                enabled
            }
            updatedAt
            updatedBy {
                id
                displayName
                email
                createdAt
                updatedAt
                enabled
            }
            salesOrders {
                totalCount
            }
        }
    }
`
